import pick from "lodash/pick";

import { initialState } from "@/vuex/store";

export default {
  update(state, payload) {
    state[payload.state] = {
      ...state[payload.state],
      ...payload.data
    };
  },
  replace(state, payload) {
    state[payload.state] = payload.data;
  },
  reset(state) {
    Object.assign(state, initialState());
  },
  toggleConfirmChanges(state, { show, ...rest }) {
    state.confirmChanges = {
      ...initialState().confirmChanges,
      ...pick(state.confirmChanges, ["resolve", "reject"]),
      ...rest,
      show: show !== undefined ? show : !state.confirmChanges.show
    };
  },
  setupConfirm(state, { resolve, reject }) {
    state.confirmChanges.resolve = resolve;
    state.confirmChanges.reject = reject;
  },
  setDictionaryItem(state, { dictionary, key, value }) {
    state[dictionary][key] = value;
  },
  appendJobDocument(state, document) {
    if (!state.job) return;
    state.job.documents = [...(state.job.documents || []), document];
  },
  removeGeneratingDocument(state, id) {
    if (!state.job?.documents) return;
    state.job.documents = state.job.documents.filter(
      (document) => !(document.id === id && document.generating)
    );
  }
};
